// Styling comes from the employees page - to be refactored to tailwind in both places
import type { FC } from 'react'

import { Td } from '@skytech/ui/Table/Td'
import { twJoin } from 'tailwind-merge'

import Highlight from '@/components/Highlight'
import { TrLink } from '@/components/TrLink'
import type { AssetLocation } from '@/resources/asset-locations'
import { APP_ROUTES } from '@/util/app-routes'

export const AssetLocationListItem: FC<
  AssetLocation & {
    searchFilter: string
  }
> = ({ department, id, searchFilter, code, hidden, name, email }) => (
  <TrLink
    path={APP_ROUTES.HARDWARE_ASSET_LOCATION.replace(':assetLocationId', String(id))}
    className={twJoin(hidden && 'text-neutral-400')}
  >
    <Td>
      <Highlight pattern={searchFilter} text={code ?? ''} />
    </Td>

    <Td>
      <Highlight pattern={searchFilter} text={name || ''} />
    </Td>

    <Td className="hidden md:table-cell">
      <div>
        <Highlight pattern={searchFilter} text={department.code} />
        {' - '}
        <Highlight pattern={searchFilter} text={department.name} />
      </div>
    </Td>
    <Td>
      <Highlight pattern={searchFilter} text={email || ''} />
    </Td>
  </TrLink>
)
